export default __webpack_public_path__ + "static/media/spaceCommander.3a5987d6.png";